import React, { ReactElement, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Col, Heading, Row } from 'idsk-react-components';
import './addSubjektBezPripomienokComponent.scss';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import routes from '../../../routing/routes';
import { useUserContext } from '../../../context/UserContext';
import AddSubjektBezPripomienokForm from './AddSubjektBezPripomienokForm';

import { useClient } from '../../../context/ClientStatusContext';
import { sendBezPripomienokAdmin } from '../../../client/sendBezPripomienokClient';
import dateToString from '../../../function/dateToString';
import PripomienkaDetailRow from '../../PripomienkaDetail/component/PripomienkaDetailRow';
import LdapItem from '../../../model/LdapItem';
import { useActionContext } from '../../../context/ConfirmActionContext';

const AddSubjektBezPripomienokComponent = (): ReactElement => {
  const { legislationProcess } = useUserContext();
  const { displaySuccess } = useSuccessMessageContext();
  const navigate = useNavigate();
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const [date, setDate] = useState(new Date());
  const [skupina, setSkupina] = useState<LdapItem>(null);
  const { wrapClient: sendBezPripomienokClient, status } = useClient(sendBezPripomienokAdmin);
  const { cancelAction, visible } = useActionContext();

  useEffect(() => {
    if (visible === true) {
      cancelAction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, skupina]);

  const onAddSubjektBezPripomienok = async (): Promise<void> => {
    await sendBezPripomienokClient(type, year, index, dateToString(date), skupina ? skupina.uuid : null);
    navigate(routes.pripomienky.list.withParams(type, year, index));
    displaySuccess('Pridanie subjektu bez pripomienok bolo úspešné.');
  };
  return (
    <div className="add-subjekt-bez-pripomienok-admin">
      <Heading size="l">
        Nový subjekt bez pripomienok (admin)
      </Heading>
      <PripomienkaDetailRow header="Názov LP:" data={legislationProcess.nazovPredpisu} />
      <section className="pripomienkovatel-section">
        <Row>
          <Col width="one-quarter">
            <Heading size="m">PRIPOMIENKOVATEĽ</Heading>
          </Col>
        </Row>
        <AddSubjektBezPripomienokForm
          onSubmit={onAddSubjektBezPripomienok}
          date={date}
          setDate={setDate}
          skupina={skupina}
          setSkupina={setSkupina}
          loading={status.loading}
        />
      </section>
    </div>
  );
};

export default AddSubjektBezPripomienokComponent;
